import realtimeSaga from "ra-realtime";
import {
  getSocketClient,
  addCreateSubscription,
  removeCreateSubscription,
} from "../serverClient";

const observeRequest = dataProvider => (type, resource, params) => {
  // Filtering so that only kiosks and stats are updated in real time
  if (resource !== "kiosks" && resource !== "statsKiosks") return;

  let socketClient;
  let getClient;
  let unsubscribed = false;

  // eslint-disable-next-line
  return {
    subscribe(observer) {
      const updateResponseHandler = rawMessage => {
        const message = JSON.parse(rawMessage.data);
        if (
          message.type === "kiosksUpdate" ||
          message.type === "statsKiosksUpdate"
        ) {
          dataProvider(type, resource, params)
            .then(results => observer.next(results)) // New data received, notify the observer
            .catch(error => observer.error(error)); // Ouch, an error occured, notify the observer
        }
      };

      getClient = () => {
        getSocketClient()
          .then(client => {
            if (!unsubscribed) {
              socketClient = client;
              client.addEventListener("message", updateResponseHandler);
            }
          })
          .catch(e =>
            console.error("Unable to create socket in realtime saga", e)
          );
      };

      getClient();
      addCreateSubscription(getClient);

      const subscription = {
        unsubscribe() {
          unsubscribed = true;
          socketClient.removeEventListener("message", updateResponseHandler);
          removeCreateSubscription(getClient);

          Promise.resolve().then(() => observer.complete());
        },
      };

      return subscription;
    },
  };
};

export default dataProvider => realtimeSaga(observeRequest(dataProvider));



// WEBPACK FOOTER //
// ./src/sagas/createRealtimeSaga.js